<template>
  <InfuseSelect
    :name="name"
    :model-value="modelValue"
    :required="required"
    :options="[]"
    :label="t('select')"
    :disabled="disabled"
    :size="size"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <optgroup :label="t('common')">
      <option
        v-for="option in store.getFrequentCountries"
        :key="`option-${option[format]}`"
        :value="option[format]"
        :selected="option[format] === modelValue"
      >
        {{ option.name }}
      </option>
    </optgroup>
    <optgroup :label="t('allCountries')">
      <option
        v-for="option in store.getNonFrequentCountries"
        :key="`option-${option[format]}`"
        :value="option[format]"
        :selected="option[format] === modelValue"
      >
        {{ option.name }}
      </option>
    </optgroup>
  </InfuseSelect>
</template>

<script lang="ts" setup>
import { CountryFormat } from '@infuse/ui/domain';
import { useCountryStore } from '@infuse/ui/stores';
import { onMounted, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { InfuseSelect } from '../index';

const emit = defineEmits(['update:modelValue']);

interface Props {
  name?: string;
  format: CountryFormat;
  modelValue: string;
  required?: boolean;
  disabled?: boolean;
  size?: 'small' | 'medium' | 'large';
}

const store = useCountryStore();
const { t, locale } = useI18n();

withDefaults(defineProps<Props>(), {
  name: 'country',
  format: 'alpha3',
  modelValue: '',
  size: 'medium'
});

onMounted(() => (store.locale = locale.value));

watch(locale, (newLocale) => {
  // only recompute on locale change
  store.locale = newLocale;
});
</script>

<i18n>
{
  "en": {
    "common": "Commonly used",
    "allCountries": "All countries",
    "select": "Select a country"
  },
  "nl": {
    "common": "Veel gebruikt",
    "allCountries": "Alle landen",
    "select": "Selecteer een land"
  }
}
</i18n>
